import moment from "moment/moment";

export const RANGE = {unitType: 'Range', displayName: 'Selected Range'};
export const TODAY = {units: 1, unitType: 'Day'};
export const DEFAULTS = [
  TODAY,
  {units: 7, unitType: 'Day', },
  {units: 30, unitType: 'Day', },
  {units: 3, unitType: 'Month', },
  {units: 6, unitType: 'Month', },
  {units: 12, unitType: 'Month', },
  RANGE,
];

export function toDateRange({ units, unitType}) {
  let today = moment().utc().startOf('day');
  return { start: moment(today).subtract(units, unitType), end: today }
}


export const findTimespan = (options) => (start, end) => {
  const found = options
    .filter(x => x.units !== undefined)
    .find(x => moment(end).utc().subtract(x.units, x.unitType).isSame(start))
  return found || RANGE
}

export function renderTimespan(ts) {
  const {displayName, units, unitType} = ts || { displayName: '' }
  return displayName !== undefined ?
    ts.displayName :
    units == TODAY.units && unitType == TODAY.unitType ?
      'Today' :
      `Last ${units} ${unitType}s`
}
